<template>
  <b-modal ref="imageModal" hide-footer size="xl" v-on:shown="isShowing = true" v-on:hidden="isShowing = false">
    <div class="carousel-wrapper" v-if="isShowing">
      <carousel ref="houseCarousel"
        :paginationEnabled=false
        :navigationEnabled=true
        :navigationNextLabel='`<i class="fa fa-chevron-right fa-3x" aria-hidden="true"></i>`'
        :navigationPrevLabel='`<i class="fa fa-chevron-left fa-3x" aria-hidden="true"></i>`'
        :perPage="1"
        :navigateTo="[selectedImage, false]">
        <slide v-for="(image, index) in photos" :key="index">
          <div class="container-fluidF">
            <div class="row h-100">
              <div class="col my-auto">
                <img class="image" v-bind:src="image">
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </b-modal>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  data () {
    return {
      hasBeenSet: false,
      isShowing: false
    }
  },
  components: {
    Carousel,
    Slide
  },
  props: {
    photos: Array,
    selectedImage: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  margin-right: 2rem;
  margin-left: 2rem;
  padding-right: 1rem;
  padding-left: 1rem;
}

.image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/ImageModal.vue